var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input--select" }, [
    _c(
      "div",
      { class: _vm.inputClasses },
      [
        !_vm.hideLabel
          ? _c(
              "label",
              { class: _vm.labelClass, attrs: { for: _vm.selectId } },
              [_vm._v(_vm._s(_vm.label))]
            )
          : _vm._e(),
        !_vm.showNativeSelect
          ? _c("v-select", {
              ref: _vm.selectId,
              class: _vm.selectClasses,
              attrs: {
                options: _vm.options,
                disabled: _vm.disabled,
                clearable: false,
                value: _vm.selectedValue,
                "input-id": _vm.selectId,
                placeholder: _vm.defaultOption,
                searchable: false,
                "select-on-tab": true
              },
              on: {
                input: _vm.update,
                click: _vm.update,
                open: function($event) {
                  return _vm.onOpen(true)
                },
                close: _vm.onOpen
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "open-indicator",
                    fn: function(ref) {
                      var openIndicatorAttributes = ref.openIndicatorAttributes
                      return [
                        _c(
                          "Icon",
                          _vm._b(
                            { attrs: { name: _vm.iconName, size: "13px" } },
                            "Icon",
                            openIndicatorAttributes,
                            false
                          )
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                3500423433
              )
            })
          : _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentValue,
                    expression: "currentValue"
                  }
                ],
                class: _vm.showNativeSelect ? "mobile-select" : "",
                attrs: { disabled: _vm.disabled, id: _vm.selectId },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentValue = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.options, function(option) {
                return _c(
                  "option",
                  { key: option.value, domProps: { value: option.value } },
                  [_vm._v(_vm._s(option.label))]
                )
              }),
              0
            )
      ],
      1
    ),
    _c("div", { staticClass: "input-error-list" }, [_vm._t("errors")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }